import request from "@/utils/request";

// 列表(主数据列表)
export function loadAppConsumerIntegralExchangeActivityBillListDataApi(data) {
  return request({
    url: "web/appConsumerIntegralExchangeActivityBill/listData",
    method: "post",
    data
  });
}
// 导出
export function loadAppConsumerIntegralExchangeActivityBillExportDataApi(data) {
  return request({
    url: "web/appConsumerIntegralExchangeActivityBill/exportData",
    method: "post",
    data
  });
}

// 操作
export function saveOrUpdateAppConsumerIntegralExchangeActivityBillApi(data) {
  return request({
    url: "web/appConsumerIntegralExchangeActivityBill/saveOrUpdate",
    method: "post",
    data
  });
}

// 查看
export function initAppConsumerIntegralExchangeActivityBillApi(data) {
  return request({
    url: "web/appConsumerIntegralExchangeActivityBill/init",
    method: "post",
    data
  });
}

// 根据条件获取条数
export function findAppConsumerIntegralExchangeActivityBillCountByConditionApi(data) {
  return request({
    url: "web/appConsumerIntegralExchangeActivityBill/findCountByCondition",
    method: "post",
    data
  });
}